<template slot-scope="scope">
  <!-- 修复 弹窗 -->
  <div >
      <dialogModel
        width="720px"
        title="修复多家"
        :visible="VisibleUp"
        @handleClose="handleClose"
        @handleOk="handleConfirm"
      >
        <div class="main-body">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="148px"
            class="demo-ruleForm"
          >
            <el-form-item label="服务类型：" prop="Type" :required="true">
                <el-radio-group
                  v-model="ruleForm.Type"
                  @change="$refs.ruleForm && $refs.ruleForm.validateField('Type')"
                >
                  <el-radio
                    v-for="item in Arr1"
                    :key="'svc-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            <el-form-item label="支付方式：">
                <el-radio-group v-model="payType">
                  <el-radio
                    v-for="item in payTypeArr"
                    :key="'pay-' + item.id"
                    :label="item.id"
                    >{{ item.name }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            <el-form-item label="上传：" required class="upload-item">
              <div class="upload-box">
                <ImportRes
                  :url="UploadUrl"
                  :Switch="ruleForm.Type"
                  :ChangeParameters="1"
                  :type="1"
                  :ClearAll="ClearAll"
                  @handleOkImport="handleOkImport"
                  @handleClose="handleClose"
                  @handleClearOut="handleClearOut"
                @upload-status="onUploadStatus"
                ></ImportRes>
                <div class="upload-tip">（上传格式为xlsx、xls文件,大小不得超过10M，请先下载模板，按照模板内容进行添加信息）</div>
              </div>
            </el-form-item>

            <div class="Price" v-if="priceVo.creditRepairCount != null">
              <div>
                信用修复：<span style="color: #ffa200">
                  共{{ priceVo.creditRepairCount }}条</span
                >
              </div>
              <div>
                价格：<span style="color: #ffa200"
                  >{{ priceVo.totalAmount }}元</span
                >
              </div>
            </div>
            <div class="Price" v-if="priceVo.totalAmount != null">
              <div>
                总价：<span style="color: #fe574a"
                  >{{ priceVo.totalAmount }}元</span
                >
              </div>
            </div>
          </el-form>
        </div>
      </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :totalAmount="totalAmount"
      :payMethod="payMethod"
      :orderId="orderId"
      :businessType="businessType"
      :businessIntent="15"
      :queryType="'proxy'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {
  pay, //支付接口
} from "../../../../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../../Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import ImportRes from "../IndexCom/ImportRes.vue";
import {
  PAYMENT_OPTIONS,
  DEFAULT_PAYMENT_METHOD,
} from "@/utils/paymentMethods";
export default {
  props: {
    VisibleUp: {},
    enterprise: {},
  },
  components: { ImportRes, CommonPayment, VerificationPwd },
  data() {
    return {
      payType: DEFAULT_PAYMENT_METHOD,
      payTypeArr: PAYMENT_OPTIONS, //支付方式选择 //支付方式选择
      alipayForm: ``,
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      Arr1: [{ id: 0, name: "企业信用修复", select: true }], //注销类型选项

      ruleForm: {
        Type: 0, //选择
      },
      rules: {
        Type: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: ["blur", "change"],
          },
        ],
      },
      VisiblePayment: false,
      paymentPassword: true, //支付密码开启/关闭
      VisiblePwd: false, //支付密码验证
      // List: [
      //   {
      //     orderCompanyName: "马锋公司",//需办理企业名称
      //     orderCreditCode: "411323199704063413",//统一社会信用代码
      //     orderLegalPerson: "mafeng",//法人姓名
      //     orderCompanyPhone: "18237742511",//联系电话
      //     itemType: 0,//服务类别 0 司法案件记录消除 1行政处罚记录消除 2其他记录消除
      //     nature: "0",//性质 原告0 被告1
      //     caseName1: "大案要案",//案件名称1
      //     caseName2: "",//案件名称2
      //     caseName3: "",//案件名称3
      //     orderTaxType: 1,//纳税类型0 小规模 1一般纳税人
      //     orderCompanyType: 0,//服务类别0有限公司/1个体户/2子公司/3分公司/4其他
      //     remark: "备注",//备注
      //   },
      // ], //上传的数据
      List: [], //上传的数据
      priceVo: {
        totalAmount: null,
        priceList: [],
      }, //上传资料返回的价格数量
      UploadUrl: "",
      ClearAll: false,
      uploading: false,
    };
  },
  watch: {
    VisibleUp: {
      handler(newSs, old) {
        if (newSs == false) {
          this.List = [];
          this.priceVo = {
            totalAmount: null,
            priceList: [],
          }; //上传资料返回的价格数量
          this.uploading = false;
          this.ClearAll = true;
        } else {
          this.ClearAll = false;
        }
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    this.UploadUrl = "/global/proxy/creditRepairUpload";
  },
  methods: {
    onUploadStatus(status) {
      this.uploading = !!status;
    },
    //点击已上传文件后方的x
    handleClearOut() {
      this.List = [];
      this.priceVo = {
        totalAmount: null,
        priceList: [],
      }; //上传资料返回的价格数量
    },
    // 上传完成
    handleOkImport(res) {
      const data = (res && res.data && res.data.data) || {};
      const list = Array.isArray(data.modelList)
        ? data.modelList
        : Array.isArray(data.businessDataList)
        ? data.businessDataList
        : [];
      this.List = Array.isArray(list) ? list : [];
      this.priceVo = data.priceVo || {
        totalAmount: data.totalPrice != null ? data.totalPrice : null,
        priceList: null,
      };
      const hasPrice =
        this.priceVo.totalAmount != null ||
        (this.priceVo.priceList &&
          Number(this.priceVo.priceList.count) > 0);
      if (!this.List.length && !hasPrice) {
        this.$tool.PromptBox("error", "上传文件解析为空请重新上传");
      }
    },
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$emit("handleSuccess");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 取消
    handleClose() {
      this.$emit("handleCloseUp");
    },
    // 确认
    handleConfirm() {
      if (this.uploading) {
        this.$tool.PromptBox("warning", "文件上传中，请稍候再确认");
        return;
      }
      if (this.List.length > 0 || this.priceVo.totalAmount != null || (this.priceVo.priceList && Number(this.priceVo.priceList.count) > 0)) {
        if (localStorage.getItem("PaymentPwd") == "false") {
          //没有开启支付密码验证直接弹支付二维码
          this.handleUnderstandPwd();
        } else {
          // 支付密码验证
          this.VisiblePwd = true;
        }
      } else {
        this.$tool.PromptBox(
          "error",
          "请上传符合模板格式的.xlsx或.xls文件且文件内容不能为空"
        );
      }
    },
    // 支付密码确认 正确
    handleUnderstandPwd(pwd) {
      var data = {
        data: {
          businessType: "CREDIT_REPAIR",
          payMethod: this.payType,
          password: pwd,
          businessInfo: {
            buyCompanyId: this.$store.getters.getCompany.id, //购买企业id
            buyCompanyName: this.enterprise.companyName, //下单企业名称
            buyCreditCode: this.enterprise.customerCreditCode, //下单企业统一社会信用代码
            buyCompanyPhone: this.enterprise.phone, //购买企业电话
            creditRepairList: this.List,
          },
        },
      };

      pay(data).then((res) => {
        if (res.code == 0) {
          this.VisiblePwd = false;
          console.log(res.data);
          this.$tool.PromptBox("success", "操作成功");
          this.alipayForm = res.data.payPage;
          this.totalAmount = res.data.totalAmount;
          this.businessType = res.data.businessType;
          this.payMethod = res.data.payMethod;
          this.orderId = res.data.orderId;
          // this.$emit("handleCloseUp");
          // this.$emit("handleConfirmUp");
          // 打开二维码弹窗
          this.VisiblePayment = true;
        } else {
          this.VisiblePwd = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../Bookkeeping/components/bookkeeping-form-dialog.less";

.is-disabled {
  pointer-events: none;
  opacity: 0.6;
  user-select: none;
}
/deep/ .el-radio-group {
  flex-wrap: wrap;
  white-space: normal;
}
.Price {
  width: 100%;
  min-height: 30px;
  line-height: 30px;
  display: flex;
  flex-wrap: wrap;
  font-size: 15px;
  font-weight: 600;
  padding-left: 148px;
  box-sizing: border-box;
  > div {
    color: #fe574a;
    margin-right: 50px;
  }
}
</style>
